import { render, staticRenderFns } from "./FileUploadAttribute.vue?vue&type=template&id=22fbc95e&scoped=true"
import script from "./FileUploadAttribute.vue?vue&type=script&lang=js"
export * from "./FileUploadAttribute.vue?vue&type=script&lang=js"
import style0 from "./FileUploadAttribute.vue?vue&type=style&index=0&id=22fbc95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fbc95e",
  null
  
)

export default component.exports